<template>

  <tr
    @click="$router.push(toRoute)"
    class="table-tr-pointer">
    <td class="text-truncate">
      <input 
        v-if="permissions.includes('manage_candidates')"
        type="checkbox" 
        :checked="selected.includes(candidate._id)" 
        :value="candidate._id" 
        @click="setCheck">
    </td>
    <td>
      <span
        @click="$event.stopPropagation()">
        <router-link
          :to="toRoute">
          <Avatar
            :src="imgSrc"
            :name="candidate.name"
            size="44px"
            radius="22px"
            resize="100x100x1" />
          </router-link>
      </span>
    </td>
    <td style="min-width: 180px">
      <span
        @click="$event.stopPropagation()">
        <router-link
          style="color: inherit;"
          :to="toRoute">
          <span
            class="text-truncate"
            style="max-width: 180px"
            v-html="candidate.highlight.name"></span>
          </router-link>
      </span>

      <div
        class="subtext"
        v-if="subtitle"
        v-html="subtitle">
      </div>

      <ul
        class="list-tags mt-1"
        v-if="candidate.tags.length">
        <li
          v-for="(tag, index) in candidate.tags"
          :key="index">
          {{ tag }}
          </li>
      </ul>
    </td>
    <td style="min-width: 180px">
      <div
        v-html="candidate.highlight.neighborhood"></div>
      <div
        class="subtext"
        v-html="candidate.highlight.city"></div>
      <div v-if="!candidate.highlight.neighborhood && !candidate.highlight.city">--</div>
    </td>
    <td>
      <div
        class="subtext"
        v-if="candidate.highlight.resume"
        v-html="candidate.highlight.resume">
      </div>
      <div v-if="!candidate.highlight.resume">--</div>
    </td>
    <!--<td class="text-truncate">
      {{ candidate.salary ? $n(candidate.salary, {style: 'decimal', minimumFractionDigits: 2}) : '-' }}
    </td>-->
    <td class="text-truncate">
      <PercentEvaluation
        :value="candidate.avg_rating ? candidate.avg_rating.evaluation : null"
        empty="--"
        :icon="true" />
    </td>
    <td
      v-if="gdprEnable"
      class="text-truncate">
      <ConsentBullet
        :gdpr="candidate.gdpr" />
    </td>
    <td>
      {{ candidate.created_at | moment('fromNow', $i18n.locale) }}
    </td>
  </tr>

</template>

<script>
import config from '@/config'
import PercentEvaluation from '@/components/Parts/PercentEvaluation'
import ConsentBullet from '@/components/Parts/ConsentBullet'
import moment from 'moment'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'candidateList',
  props: {
    candidate: {
      type: Object,
      default: () => { return {} }
    },
    keywords: {
      type: String,
      default: null
    }
  },
  components: {
    PercentEvaluation,
    ConsentBullet,
    Avatar
  },
  data () {
    return {
    }
  },
  computed: {
    gdprEnable () {
      const account = this.$store.getters.getAccount
      return account.settings.gdpr
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    subtitle () {
      return [
        this.candidate.highlight.headline,
        this.candidate.birth_date ? this.$t('n_years', { age: moment().diff(moment(this.candidate.birth_date), 'years') }) : null
      ]
      .filter(v => v)
      .join(', ')
    },
    toRoute () {
      return {
        query: {
          ...this.$clone(this.$route.query),
          candidate_id: this.candidate._id
        }
      }
    },
    selected () {
      return this.$store.getters.getCandidateSelectedIds
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    /*
    setCheck
    */
    setCheck (event) {
      this.$store.dispatch('toggleCandidateSelected', event.target.value)
      event.stopPropagation()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/CandidateList/CandidateListItem.vue